// SECRET_KEY stond hier: hij kwam uit REACT_APP_SECRET_KEY en werd daarna nergens gebruikt. Dode
// code met een sleutel erin, en alles in een .env belandt in het gebouwde bestand -- dus openbaar.
// Weggehaald bij JIMANI-SEC-001, 14-09-2026.
import { apiAdres } from '../instellingen';
const BASE_URL = apiAdres;

// Het gastbewijs (RR2, 05-10-2026): Een externe koppeling zet het als &gastbewijs=... achter de widgetlink van een gekoppelde gast. Alleen
// daarmee geeft de api een token voor de gastgegevens. Bewaard voor de sessie, want de widget navigeert verder zonder de parameter.
const gastbewijs = () => {
  try {
    const uitAdres = new URLSearchParams(window.location.search).get('gastbewijs');
    if (uitAdres) sessionStorage.setItem('gastbewijs', uitAdres);
    const waarde = uitAdres || sessionStorage.getItem('gastbewijs');
    return waarde ? '&gastbewijs=' + encodeURIComponent(waarde) : '';
  } catch {
    return '';
  }
};

// De sms-uitnodiging (link https://dashboard.jimani.online/r/{code}, die naar de widget doorstuurt met &sms={code}): de code van 14 tekens
// wordt bewaard voor de sessie, want de widget navigeert verder zonder de parameter. Hij wordt ook meteen bij het laden van dit bestand
// gelezen, nog voor een route de adresbalk kan veranderen.
const SMS_SLEUTEL = 'smscode';
const SMS_PATROON = /^[A-Za-z0-9]{14}$/;
export const smsCode = () => {
  try {
    const uitAdres = new URLSearchParams(window.location.search).get('sms');
    if (uitAdres && SMS_PATROON.test(uitAdres)) sessionStorage.setItem(SMS_SLEUTEL, uitAdres);
    const waarde = sessionStorage.getItem(SMS_SLEUTEL);
    return waarde && SMS_PATROON.test(waarde) ? waarde : '';
  } catch {
    return '';
  }
};
export const wisSmsCode = () => {
  try { sessionStorage.removeItem(SMS_SLEUTEL); } catch { /* geen opslag: niet erg */ }
};
smsCode();

const apiEndpoints = {
  USER_LOGIN: `${BASE_URL}api/Account/authenticate`,
  AUTH_LOGIN: `${BASE_URL}api/Account/authenticate`,
  GET_AVAILABLETICKETING_COMBINATION: `${BASE_URL}api/Combination/GetWidgetAvailableTicketingCombinationById`,
  // Wat de server voor de gekozen onderdelen van een combinatie rekent, na korting (besluit Martijn 11-10-2026).
  COMBINATIE_ONDERDEELPRIJZEN: `${BASE_URL}api/Combination/Onderdeelprijzen`,
  GET_EXTERANAL_DEVICE_CONFIG: (key,UID) => `${BASE_URL}api/DeviceIntegration/GetExternalDeviceConfiguration?key=${key}&UID=${UID}`,
  GET_COMBINATION_LIST_RESERVATION: (key) =>
    `${BASE_URL}api/Widget/GetCombinationWidgetList?key=${key}`,
  GET_GUEST_DETAILS_BYKEY: (key, guestId) =>
    `${BASE_URL}api/Widget/GetGuestDetailsByKey?key=${key}&guestId=${guestId}`,
  GET_LANGUAGE: (key) => `${BASE_URL}api/Widget/GetLanguages?key=${key}`,
  GET_WIDGET_SETTING: (language, key) =>
    `${BASE_URL}api/Widget/GetSettings?key=${key}&lang=${language}`,
  GET_WIDGET_TITLE_AND_INFO: (setupID, language) =>
    `${BASE_URL}api/Widget/GetWidgetTitleandInfo?idwidgetsetup=${setupID}&lang=${language}`,
  GET_WIDGET_POSITION: (setupID) =>
    `${BASE_URL}api/Widget/GetWidgetPosition?idwidgetsetup=${setupID}`,
  GET_WIDGET_SETUP: (setupID) =>
    `${BASE_URL}api/Widget/GetWidgetSetup?idwidgetsetup=${setupID}`,
  GET_WIDGETS_CONFIG: (key, id, lang, guestid) =>
    `${BASE_URL}api/Widget/GetWidgetSettings?key=${key}&idwidget=${id}&lang=${
      lang ? lang : "EN"
    }${guestid ? `&guestId=${guestid}${gastbewijs()}` : ""}`,
  GET_CALENDER_DETAILS: (
    key,
    noOfGuests,
    widgetId,
    reservationRequestMin = 0,
    reservationRequestMax = 0
  ) =>
    `${BASE_URL}api/Widget/GetWidgetChecksOnFieldChange?key=${key}&numberOfGuests=${noOfGuests}&idwidgetsetup=${widgetId}&reservationRequestMin=${reservationRequestMin}&reservationRequestMax=${reservationRequestMax}`,
  GET_RESERVATION_TYPE: `${BASE_URL}api/Widget/GetReservationTypes`,
  GET_PRODUCTS_RESERVATION_TUPE: (key, idproducthoreca) =>
    `${BASE_URL}api/Widget/GetProductForReservationType?key=${key}&idproducthoreca=${idproducthoreca}`,
  GET_FREE_TABLES: `${BASE_URL}api/Widget/GetFreeTables`,
  GET_SMS_UITNODIGING: (key, code, lang) =>
    `${BASE_URL}api/Widget/GetSmsuitnodiging?key=${encodeURIComponent(key)}&code=${encodeURIComponent(code)}&lang=${encodeURIComponent(lang || "")}`,
  GET_RESERVATION_GROUP_TYPE: `${BASE_URL}api/Widget/GetReservationGroupTypes`,
  GET_GUEST_DETAILS: (key, ID, lang,mainModuleId) =>
    // `${BASE_URL}api/Widget/GetFields?id=${ID}&key=${key}&lang=${lang}`,
    `${BASE_URL}api/Widget/GetGuestDetails?idreservationtype=${ID}&key=${key}&lang=${lang}&mainModuleId=${mainModuleId}`,
  CREATE_RESERVATION: `${BASE_URL}api/Widget/CreateReservation `,
  TRANSACTIONCOST_RESTYPE: (key, ID, lang) =>
    `${BASE_URL}api/Widget/GetTransactionCostForReservationType?key=${key}&idreservationtype=${ID}&lang=${lang}`,
  GET_FEEDBACK: (key,lang,type) => `${BASE_URL}api/Widget/GetEnquete?secretkey=${key}&lang=${lang}&mainModuleId=${type}`,
  CREATE_FEEDBACK: `${BASE_URL}api/Widget/CreateEnquete`,
  CANCEL_RESERVATION: `${BASE_URL}api/Widget/CancelReservation`,
  GET_OPENING_HOURS: (key, lang,url) =>
    `${BASE_URL}api/Widget/${url}?key=${key}&lang=${lang}`,
    GET_OPENING_HOURS_SALON: (key, lang) =>
    `${BASE_URL}api/Widget/GetSalonOpeningsHours?key=${key}&lang=${lang}`,
  GET_EXTRA_INFO_FIELDS: (resID, lang, key,widgetId) =>
    `${BASE_URL}api/Widget/GetFields?id=${resID}&lang=${lang}&key=${key}&idWidgetSetup=${widgetId}`,
  GET_RESERVATION_PDF: (key,secretkey,mainModuleId) =>
    `${BASE_URL}api/Widget/GetReservationPdf?key=${key}&secretkey=${secretkey}&mainModuleId=${mainModuleId}`,

  CREATE_GUEST: `${BASE_URL}api/Widget/CreateGuest`,
  Activites: {
    GET_CATEGORIES:(key)=>`${BASE_URL}api/Activities/GetActivityCategories?key=${key}`,
    GET_ACTIVITIES: (key, lang, id, date, totalCount, field1, field2, field3, field4, field5) =>
      `${BASE_URL}api/Activities/GetActivities?key=${key}&lang=${lang}&idwidget=${id}&date=${date}&noOfGuest=${totalCount}&field1=${field1}&field2=${field2}&field3=${field3}&field4=${field4}&field5=${field5}`,
    GET_ACTIVITY_DAYS_CLOSED: (key) =>
      `${BASE_URL}api/Activities/GetActivityDaysClosed?key=${key}`,
    GET_ACTIVITY_TIMES: `${BASE_URL}api/Activities/GetActivityTimes`,
    CREATE_ACTIVITY_RESERVATION: `${BASE_URL}api/Activities/CreateActivityReservation`,
    GET_COMBINATION_LIST: `${BASE_URL}api/Combination/GetCombinationList`,
    GET_COMBINATION_BY_ID: `${BASE_URL}api/Combination/GetWidgetAvailableCombinationById`,
    GET_AVAILABLE_LOCATION: `${BASE_URL}api/Activities/GetAvailableLocation`,
  },
  TICKETING: {
    GET_EVENTS_OR_STANDARD_TICKETS: (key, lang, iswidget, isStandardTicket,idWidget) =>
      `${BASE_URL}api/Widget/GetEventsOrStandardTickets?key=${key}&languageCode=${lang}&isWidget=${iswidget}&isStandardTicket=${isStandardTicket}&idWidget=${idWidget}`,
    GET_STD_TICKETS_DATES: (key) =>
      `${BASE_URL}api/Widget/GetDatesForStandardTickets?key=${key}`,
    GET_EVENT_TICKET_DATES: (eventTicketId) =>
      `${BASE_URL}api/Widget/GetDatesForEventTickets?eventTicketId=${eventTicketId}`,
    GET_EVENTS_OR_STANDARD_TICKETS_TYPES: (
      key,
      lang,
      ticketId,
      date,
      isStandardTicket
    ) =>
      `${BASE_URL}api/Widget/GetEventOrStandardTicketTypes?key=${key}&languageCode=${lang}&eventTicketId=${ticketId}&ticketDate=${date}&isStandardTicket=${isStandardTicket}`,
    CREATE_TICKET_RESERVATION: `${BASE_URL}api/Widget/AddTicketingReservation`,
    // De kaartverkoopwidget (opdracht 2E, 11-10-2026): wat er te koop is op welke dagen, en het aanbod van een dag.
    KALENDER: (key, widgetSetupId, lang) =>
      `${BASE_URL}api/Kaartverkoop/Kalender?key=${encodeURIComponent(key)}&widgetSetupId=${widgetSetupId}&lang=${encodeURIComponent(lang || "")}`,
    DAG: (key, widgetSetupId, lang, datum) =>
      `${BASE_URL}api/Kaartverkoop/Dag?key=${encodeURIComponent(key)}&widgetSetupId=${widgetSetupId}&lang=${encodeURIComponent(lang || "")}&datum=${datum}`,
  },

  CHECK_ORDER_STATUS: (orderId) =>
    `${BASE_URL}api/Webshop/checkOrderStatus/${orderId}`,
  CANCEL_ORDER_READDSTOCK: (orderId) =>
    `${BASE_URL}api/Webshop/cancelOrderAndRestock/${orderId}`,
  CURRENCY_ENDPOINT: (key) =>
    `${BASE_URL}api/Widget/GetCompanyCurrency?key=${key}`,

  GET_EXTRA_PRODUCTS_DETAILS: (ID, lang,key) =>
    `${BASE_URL}api/Widget/GetUpsaleProductsForReservationType?idreservationtype=${ID}&lang=${lang}&key=${key}`,

  GET_RESERVATION_DETAILS: (key, secretKey,mainModuleId) =>
    `${BASE_URL}api/Widget/GetReservationDetails?key=${key}&secretkey=${secretKey}&mainModuleId=${mainModuleId}`,

  GET_WEBSHOP_WIDGET_SETTINGS: (KEY) =>
    `${BASE_URL}api/Webshop/GetWebshopWidgetSetup?key=${KEY}`,
  GET_WEBSHOP_CATEGORIES: (KEY, LANG,ID) =>
    `${BASE_URL}api/Webshop/GetWebshopCategories?key=${KEY}&lang=${LANG}&id=${ID}`,
  GET_WEBSHOP_PRODUCTSLIST: (KEY, LANG, CategoryId) =>
    `${BASE_URL}api/Webshop/GetWebshopProductList?key=${KEY}&lang=${LANG}&idcategory=${CategoryId}`,
  // De subcategorieen van een hoofdcategorie (16-10-2026): kopjes met afbeelding en naam in de taal van de bezoeker.
  GET_WEBSHOP_SUBCATEGORIEEN: (KEY, LANG, CategoryId) =>
    `${BASE_URL}api/Webshop/GetWebshopSubcategorieen?key=${KEY}&lang=${LANG}&idcategory=${CategoryId}`,
  GET_WEBSHOP_PRODUCT_DETAILS: (KEY, LANG, PRODUCTID) =>
    `${BASE_URL}api/Webshop/GetProductDetails?key=${KEY}&lang=${LANG}&idproduct=${PRODUCTID}`,
  GET_WEBSHOP_OPENINGHOURS: (DATE, KEY) =>
    `${BASE_URL}api/Webshop/GetWebshopOpeningHour?date=${DATE}&key=${KEY}`,
  GET_WEBSHOP_FIELDS: (KEY, LANG) =>
    `${BASE_URL}api/Webshop/GetWebshopFields?key=${KEY}&lang=${LANG}`,
  CREATE_WEBSHOP_ORDER: `${BASE_URL}api/Webshop/CreateOrder`,
  // Webshop-opties per widget en de bewerkmodus (golf 1C, 10-10-2026).
  GET_WEBSHOP_WIDGET_OPTIES: (KEY, WIDGETSETUPID) =>
    `${BASE_URL}api/Webshop/GetWebshopWidgetOpties?key=${encodeURIComponent(KEY)}&widgetSetupId=${encodeURIComponent(WIDGETSETUPID)}`,
  BEWERKEN_CONTROLE: (KEY) => `${BASE_URL}api/Webshopbewerken/Controle?key=${encodeURIComponent(KEY)}`,
  BEWERKEN_PRODUCT: (KEY, LANG, PRODUCTID) =>
    `${BASE_URL}api/Webshopbewerken/Product?key=${encodeURIComponent(KEY)}&lang=${encodeURIComponent(LANG || '')}${PRODUCTID ? `&idproduct=${encodeURIComponent(PRODUCTID)}` : ''}`,
  // AI-voorstellen in de bewerkmodus (11-10-2026): voorstel en het saldo van het Jimani AI-tegoed.
  BEWERKEN_VOORSTEL: (KEY, LANG) =>
    `${BASE_URL}api/Webshopbewerken/Voorstel?key=${encodeURIComponent(KEY)}&lang=${encodeURIComponent(LANG || '')}`,
  BEWERKEN_AITEGOED: (KEY) => `${BASE_URL}api/Webshopbewerken/Aitegoed?key=${encodeURIComponent(KEY)}`,
  // Bezorgplanning (13-10-2026): bezorgdagen en tijdsloten bij een postcode.
  GET_BEZORGMOMENTEN: (key, postcode) =>
    `${BASE_URL}api/Webshop/GetBezorgmomenten?key=${encodeURIComponent(key)}&postcode=${encodeURIComponent(postcode || '')}`,
  GET_DELIVERY_SLOTS: (key, soort) =>
    `${BASE_URL}api/Webshop/GetDeliverySlotsWithPendingOrders?key=${key}${soort ? `&soort=${encodeURIComponent(String(soort).toLowerCase())}` : ''}`,
  TV: {
    DINE_IN_RECEIVED: (key) =>
      `${BASE_URL}api/Webshop/GetCurrentDateDineInWebshopOrdersReceived?key=${key}`,
    DINE_IN_READY: (key) =>
      `${BASE_URL}api/Webshop/GetCurrentDateDineInWebshopOrdersReady?key=${key}`,
    DINE_IN_PROGRESS: (key) =>
      `${BASE_URL}api/Webshop/GetCurrentDateDineInWebshopOrdersInProgress?key=${key}`,
    PICKUP_RECEIVED: (key) =>
      `${BASE_URL}api/Webshop/GetCurrentDatePickupWebshopOrdersReceived?key=${key}`,
    PICKUP_READY: (key) =>
      `${BASE_URL}api/Webshop/GetCurrentDatePickupWebshopOrdersReady?key=${key}`,
    PICKUP_IN_PROGRESS: (key) =>
      `${BASE_URL}api/Webshop/GetCurrentDatePickupWebshopOrdersInProgress?key=${key}`,
  },
  GET_WIDGET_SETTINGS_SALON:(key,id,lang,guestId)=>`${BASE_URL}api/Widget/GetWidgetSettings?key=${key}&idwidget=${id}&lang=${lang}&guestId=${guestId}${guestId ? gastbewijs() : ""}`,
  GET_GENDER_DETAILS: (key,lang)=>`${BASE_URL}api/Salon/GetGenderList?key=${key}&lang=${lang}`,
  GET_TREATMENT:(key,lang,idGender,id)=>`${BASE_URL}api/Salon/GetTreatmentsByGender?key=${key}&lang=${lang}&idGender=${idGender}&id=${id}`,
  GET_PROFEESIONALS:(key,lang,idTreatment)=>`${BASE_URL}api/Salon/GetProfessionalByTreatment?key=${key}&lang=${lang}&idTreatment=${idTreatment}`,
  GET_AVAILABILITY_DATE_PROFFESIONAL:(key,idProfessional,idTreatment,isNoPrefrence)=>`${BASE_URL}api/Salon/GetAvailabilityDatesOfProfessional?key=${key}&idProfessional=${idProfessional}&idTreatment=${idTreatment}&isNoPreference=${isNoPrefrence}`,
  GET_AVAILABILITY_TIME_PROFESSIONAL:(key,idProfessional,idTreatment,date,isNoPrefrence)=>`${BASE_URL}api/Salon/GetAvailabilityTimesWithDateOfProffessional?key=${key}&idProfessional=${idProfessional}&idTreatment=${idTreatment}&date=${date}&isNoPreference=${isNoPrefrence}`,
  GET_UPSALE_PRODUCT_BY_TREATMENTBYID:(key,idTreatment)=>`${BASE_URL}api/Salon/GetUpsaleProductsByTreatmentId?key=${key}&idTreatment=${idTreatment}`,
  GET_AVAILABLE_CHAIR_BY_PROFFESIONAL:(key,idProfessional,date,fromTime,toTime)=>`${BASE_URL}api/Salon/GetChairsByProfessionalDateTime?key=${key}&idProfessional=${idProfessional}&date=${date}&fromTime=${fromTime}&toTime=${toTime}`,
  GET_GUEST_DETAILS_SALON:(key,lang)=>`${BASE_URL}api/Salon/GetGuestDetailsField?key=${key}&lang=${lang}`,
  CREATE_RESERVATION_SALON:`${BASE_URL}api/Salon/CreateSalonReservationForWidget`,
  GET_SALON_FIELDS:(id,lang,key)=>`${BASE_URL}api/Widget/GetFields?id=${id}&lang=${lang}&key=${key}`,
  GET_SALON_ADDITIONAL_FIELDS:(id,lang,key)=>`${BASE_URL}api/Salon/GetSalonFields?IdSalonTreatment=${id}&Lang=${lang}&Key=${key}`,
  GET_TRANSACTIONCOST_SALON:(key,idTreatment,lang)=>`${BASE_URL}api/Salon/GetTransactionCostForSalonTreatment?key=${key}&idTreatment=${idTreatment}&lang=${lang}`,
  GET_CHAIRS:(key,idprofessional,date,fromTime,toTime)=>`${BASE_URL}api/Salon/GetChairsByProfessionalDateTime?key=${key}&idProfessional=${idprofessional}&date=${date}&fromTime=${fromTime}&toTime=${toTime}`,
  
};
export default apiEndpoints;
